import { render, staticRenderFns } from "./WelcomeContentFooter.vue?vue&type=template&id=6c67358e&"
import script from "./WelcomeContentFooter.vue?vue&type=script&lang=js&"
export * from "./WelcomeContentFooter.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeContentFooter.vue?vue&type=style&index=0&id=6c67358e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports